<template>
  <div class="page">
    <!-- formTop start -->
    <div class="formTop">
      <span class="tab" :class="{act:menuSelindex==0}" @click="changeLoginType(0)">个人登录 <em class="line">&nbsp;</em></span>
      <span class="tab" :class="{act:menuSelindex==1}" @click="changeLoginType(1)">团体登录</span>
    </div>
    <!-- formTop end -->

    <!-- formPanels start -->
    <div class="formPanels">
      <!-- 个人登录-->
      <div v-if="menuSelindex==0" class="panel">
        <div class="ipt" :class="personphoneerror?'err':''">
          <!-- 错误状态，加err -->
          <!-- <input v-model="personphone" type="text" placeholder="请输入手机号" @change="inputPhone"> -->
          <el-input v-model="personphone" placeholder="请输入您的手机号" size="normal" @change="inputPhone" />
        </div>
        <!-- 错误提示 -->
        <div v-if="personphoneerror" class="err-tip">请正确填写手机号</div>

        <!-- 验证码 -->
        <div class="ipt code" :class="personcodeerror?'err':''">
          <!-- <input v-model="personcode" type="text" class="verificationCode" placeholder="请输入验证码" @change="inputCode" > -->
          <el-input v-model="personcode" placeholder="请输入短信验证码" size="normal" @change="inputCode" />
          <a href="javascript:;" class="getCode" :class="personcodebtntext!='获取短信验证码'?'getCode-grey':''" @click="verifyapply">{{ personcodebtntext }}</a>
        </div>
        <div v-if="personcodeerror" class="err-tip">请输入正确的验证码</div>

      </div>

      <!-- 团体登录 -->
      <div v-else class="panel">
        <div class="ipt" :class="groupphoneerror?'err':''">
          <!-- 错误状态，加err -->
          <!-- <input type="text" placeholder="请输入手机号" :value="groupphone" data-type="groupphone" @change="inputTeamPhone"> -->
          <el-input v-model="groupphone" placeholder="请输入您的手机号" size="normal" @change="inputTeamPhone" />
        </div>
        <div v-if="groupphoneerror" class="err-tip">请正确填写手机号</div>

        <!-- 验证码 -->
        <div class="ipt code" :class="groupcodeError?'err':''">
          <!-- <input v-model="groupcode" type="text" class="verificationCode" placeholder="请输入短信验证码" @change="inputTeamCode"> -->
          <el-input v-model="groupcode" placeholder="请输入短信验证码" size="normal" @change="inputTeamCode" />
          <a href="javascript:;" class="getCode" :class="groupcodebtntext!='获取短信验证码'?'getCode-grey':''" @click="verifyapply">{{ groupcodebtntext }}</a>
        </div>
        <div v-if="groupcodeError" class="err-tip">请输入正确的验证码</div>
      </div>

      <!-- 登录按钮 -->
      <div class="form-btns">
        <a class="btn-blue" @click="requestLogin">登录</a>
        <div v-show="menuSelindex==0" class="agreeInfo">未注册手机验证后自动登录，注册即代表同意<a href="javascript::" class="toAgreement" @click="goProfilePage('potocal')">《服务使用协议》</a> <a href="javascript::" class="toAgreement" @click="goProfilePage('secret')">《个人信息保护政策》</a></div>
        <div v-show="menuSelindex==1" class="agreeInfo tc"><a href="javascript::" class="toAgreement" @click="goProfilePage('potocal')">《服务使用协议》</a> </div>
      </div>
    <!-- formPanels end -->
    </div>
    <verify ref="verify" :mode="'pop'" :captcha-type="'blockPuzzle'" :img-size="{ width: '330px', height: '155px' }" @success="verifySuccess" />
  </div>
</template>

<script>
import api from '../../../api/auth.js'
import auth from '../../../models/auth.js'
import user from '../../../models/user.js'
import verify from '@/components/verifition/Verify.vue'

export default {
  name: 'Waplogin',
  components: {
    verify
  },
  data() {
    return {
      menuSelindex: 0,

      redirectUrl: '',

      personphone: '',
      personcode: '',
      persontimer: null,
      persontimeremain: 60,
      personcodebtntext: '获取短信验证码',
      personphoneerror: false,
      personcodeerror: false,

      groupphone: '',
      groupcode: '',
      grouptimer: null,
      grouptimeremain: 60,
      groupcodebtntext: '获取短信验证码',
      groupphoneerror: false,
      groupcodeError: false,
      skip: null

    }
  },
  created() {
    this.skip = this.$route.query.skip || 'y'
    // this.wxcode = this.$route.query.code || 0
    this.redirectUrl = this.$route.query.r || '/'
    // if (this.wxcode) {
    //   this.requestLoginByWxcode()
    // }
  },
  methods: {
    changeLoginType(t) {
      this.menuSelindex = t
    },
    getPhoneCode(code) {
      if (this.menuSelindex === 0) {
        if (this.personcodebtntext !== '获取短信验证码') {
          return
        }
        if (!(/^1[3456789]\d{9}$/.test(this.personphone))) {
          console.error(`填写正确的手机号${this.personphone}`)
          return
        }

        const params = {
          phone: this.personphone,
          captchaVerification: code,
          clientUid: localStorage.getItem('slider')
        }
        console.log(params)
        const that = this
        api.sliderCheck(params).then(r => {
          console.log(r)
          that.timeRemain()
        }).catch(err => {
          console.error(err)
        })
      } else {
        if (this.groupcodebtntext !== '获取短信验证码') {
          return
        }
        if (!(/^1[3456789]\d{9}$/.test(this.groupphone))) {
          console.error(`填写正确的手机号${this.groupphone}`)
          return
        }

        const params = {
          phone: this.groupphone,
          captchaVerification: code,
          clientUid: localStorage.getItem('slider')
        }
        console.log(params)
        const that = this
        api.sliderCheck(params).then(r => {
          console.log(r)
          that.timeRemain()
        }).catch(err => {
          console.error(err)
        })
      }
    },
    timeRemain() {
      if (this.menuSelindex === 0) {
        if (!this.persontimer) {
          const that = this
          const timer = setInterval(() => {
            that.persontimeremain = that.persontimeremain - 1
            if (that.persontimeremain === 0) {
              that.persontimeremain = 60
              clearInterval(timer)
              that.persontimer = null
              that.personcodebtntext = '获取短信验证码'
              that.personcode = ''
            } else {
              that.personcodebtntext = `${that.persontimeremain}s后重新获取`
            }
          }, 1000)
          this.persontimer = timer
        }
      } else {
        if (!this.grouptimer) {
          const that = this
          const timer = setInterval(() => {
            that.grouptimeremain = that.grouptimeremain - 1
            if (that.grouptimeremain === 0) {
              clearInterval(timer)
              that.grouptimeremain = 60
              that.grouptimer = null
              that.groupcodebtntext = '获取短信验证码'
              that.groupcode = ''
            } else {
              that.groupcodebtntext = `${that.grouptimeremain}s后重新获取`
            }
          }, 1000)
          this.grouptimer = timer
        }
      }
    },
    goProfilePage(e) { // 跳转到静态页面
      this.$router.replace({
        name: 'Wapprofile',
        query: {
          t: e
        }
      })
    },
    inputPhone(e) {
      this.personphone = e
      this.personphoneerror = !(/^1[3456789]\d{9}$/.test(this.personphone))
      console.log(this.personphoneerror)
    },
    inputCode(v) {
      this.personcode = v
      if (!this.personcode) {
        this.personcodeerror = true
      } else {
        this.personcodeerror = false
      }
    },
    inputTeamPhone(v) {
      this.groupphone = v
      this.groupphoneerror = !(/^1[3456789]\d{9}$/.test(this.groupphone))
    },
    inputTeamCode(v) {
      this.groupcode = v
      if (!this.groupcode) {
        this.groupcodeError = true
      } else {
        this.groupcodeError = false
      }
    },
    verifyapply() {
      if (this.menuSelindex === 0) {
        if (this.personphoneerror || this.personphone === '') {
          return
        }
        if (this.personcodebtntext === '获取短信验证码') {
          this.$refs.verify.show()
        }
      } else {
        if (this.groupphoneerror || this.groupphone === '') {
          return
        }
        if (this.groupcodebtntext === '获取短信验证码') {
          this.$refs.verify.show()
        }
      }
    },
    verifySuccess(params) {
      this.getPhoneCode(params.captchaVerification)
    },
    requestLogin() {
      var params = {}
      if (this.menuSelindex === 0) {
        if (this.personphoneerror || this.groupphoneerror) {
          return
        }
        params = {
          code: this.personcode,
          phone: this.personphone,
          userType: 1,
          tenantId: this.$store.getters.tenantId
        }
      } else {
        if (this.personcodeerror || this.groupcodeError) {
          return
        }
        params = {
          code: this.groupcode,
          phone: this.groupphone,
          userType: 2,
          tenantId: this.$store.getters.tenantId
        }
      }
      const that = this
      api.loginWithPhoneCode(params).then(r => {
        that.$store.dispatch('user/setToken', r.data.authInfo)
        console.log(r.data.authInfo)
        user.updateUser()

        if (params.userType === 2) {
          that.$router.push({
            path: that.redirectUrl
          })
        } else {
          if (parseInt(r.data.userInfo.authentication)) {
            that.$router.push({
              path: that.redirectUrl
            })
          } else {
            that.$router.push({
              name: 'Wapidentify',
              query: {
                r: that.redirectUrl,
                skip: that.skip
              }
            })
          }
        }
      }).catch(err => {
        that.$message({
          showClose: false,
          message: err.message,
          type: 'error'
        })
      })
    },
    toPotocal() { // 协议页面
      const routeData = this.$router.resolve({
        name: 'Profile',
        query: {
          t: 'potocal'
        }
      })
      window.open(routeData.href, '_blank')
    },
    toSecret() { // 隐私页面
      const routeData = this.$router.resolve({
        name: 'Profile',
        query: {
          t: 'secret'
        }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style src="@/styles/wap.scss" lang="scss" scoped></style>
<style>

</style>
